import React from "react";

import "./notifications.css";
import { FaEllipsisH, FaRegCheckCircle } from "react-icons/fa";
export const Notification = () => {
  return (
    <div className="notifPage row">
      <div className="col-md-3"></div>
      <div className="notifications col-md-6">
      <div className="notifContent">
      <p>
      Nuage des points: Vous avez des nouvelles mises à jour : des nouveaux livrables sont mis à votre disposition
        </p>
        <p className="notifTime"> 2min   <FaEllipsisH style={{width:"15", height:"15"}}/></p>
       </div>
      
        <hr></hr>
        <div className="notifContent">
      <p>
      Modelisation 3D: Vous avez des nouvelles mises à jour : des nouveaux livrables sont mis à votre disposition
        </p>
        <p className="notifTime"> 5min   <FaEllipsisH style={{width:"15", height:"15"}}/></p>
       </div>
        <hr></hr>
        <div className="notifContent">
      <p>
      Modelisation 3D:  Vous avez des nouvelles mises à jour : des nouveaux livrables sont mis à votre disposition
        </p>
        <p className="notifTime"> 10min   <FaEllipsisH style={{width:"15", height:"15"}}/></p>
       </div>
        <hr></hr>
        <div className="notifContent">
      <p>
      Vous avez des nouvelles mises à jour : des nouveaux livrables sont mis à votre disposition
        
        </p>
        <p className="notifTime"> 17min   <FaEllipsisH style={{width:"15", height:"15"}}/></p>
       </div>
       <hr></hr>
       <div className="notifContent">
      <p>
      Vous avez des nouvelles mises à jour : des nouveaux livrables sont mis à votre disposition
        </p>
        <p className="notifTime"> 20min   <FaEllipsisH style={{width:"15", height:"15"}}/></p>
       </div>
       <hr></hr>
       <div className=" text-center">C'est tout pour aujourd'hui &ensp;
       <FaRegCheckCircle style={{width:"25", height:"25"}}/>
       </div>
   
       
      </div>
      <div className="col-md-3"></div>
    </div>
  );
};
